/**
 * @deprecated
 * User confirm-button/confirm-button.js instead
 */

import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';

@autobind
class DeleteButton extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			showConfirmation: false
		};
	}

	render () {
		return (
			<div className="delete-button-container">
				{ this.renderConfirmation() }
				{  this.renderChildren() }
			</div>
		);
	}

	renderChildren () {
		const { children } = this.props;

		if (_.isEmpty(children)) {

			return this.renderDefaultButton();
		}

		return React.Children.map(children, (child) => {
			return React.cloneElement(child, {
				onClick: this.onDeleteClick
			});
		});
	}

	renderDefaultButton () {
		const { label = 'Delete' } = this.props;
		return (
			<button className="button alert" onClick={ this.onDeleteClick }>
				{ label }
			</button>
		);
	}

	renderConfirmation () {
		const { showConfirmation = false } = this.state;

		if (showConfirmation !== true) {

			return null;
		}

		const {
			confirmLabel = 'Confirm',
			cancelLabel = 'Cancel',
			warningText = 'Really delete item?',
			orientation = 'center'
		 } = this.props;

		return (
			<div className={ `delete-button-confirmation ${ orientation } admin-card padding-1` }>
				<div className="up-arrow bg"></div>
				<div className="up-arrow"></div>

				<p>{ warningText }</p>

				<div className="grid-x grid-padding-x align-middle">
					<div className="cell auto">
						<button className="button neo alert margin-0 expanded" onClick={ this.onConfirmClick }>{ confirmLabel }</button>
					</div>
					<div className="cell auto">
						<button className="button neo secondary margin-0 expanded" onClick={ this.onCancelClick }>{ cancelLabel }</button>
					</div>
				</div>
			</div>
		);
	}

	onDeleteClick (evt) {
		const { onDeleteClick = () => {} } = this.props;
		evt.stopPropagation();

		this.setState({
			showConfirmation: true
		});

		onDeleteClick(evt);
	}

	onConfirmClick (evt) {
		const { onConfirmClick = () => {} } = this.props;
		evt.stopPropagation();

		this.setState({
			showConfirmation: false
		});

		onConfirmClick(evt);
	}

	onCancelClick (evt) {
		const { onCancelClick = () => {} } = this.props;
		evt.stopPropagation();

		this.setState({
			showConfirmation: false
		});

		onCancelClick(evt);
	}
}

export default DeleteButton;
